/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  clearBundlesToCompare,
  selectBundlesToCompare,
  selectRetrofitConfiguration,
  setCurrentFiltersStepperStep,
  setBundle,
  setShowAxisPopup,
  selectCurrentFiltersStepperStep
} from "../../../Retrofit/store/slices/retrofit";
import { logEvent } from "../../../Common/utils/api/api";
import t from "../../../Common/utils/translation/translator";
import Button from "../../../Common/components/Buttons/Button/Button";
import MsxIcons from "../../../Common/components/Icons/MsxIcons/MsxIcons";
import useCheckMobileScreen from "../../../Common/utils/useCheckMobileScreen";
import { selectEventsData, updateConfiguration } from "../../../Common/store/slices/common";

const ComparisonBar = () => {
  const dispatch = useDispatch();
  const eventsData = useSelector(selectEventsData);
  const configuration = useSelector(selectRetrofitConfiguration);
  const bundlesToCompare = useSelector(selectBundlesToCompare);
  const isMobile = useCheckMobileScreen();
  const currentFiltersStep = useSelector(selectCurrentFiltersStepperStep);

  const handleCompare = () => {
    logEvent(eventsData.locale, eventsData.types.compare, eventsData.tags.none, configuration?.configId);
    dispatch(setCurrentFiltersStepperStep(2));
  };

  const handleGoBackToResults = () => {
    dispatch(setCurrentFiltersStepperStep(1));
  };

  const handleClearComparator = () => {
    dispatch(clearBundlesToCompare());
    dispatch(setCurrentFiltersStepperStep(1));
  };

  // eslint-disable-next-line no-unused-vars
  const handleSelectBundle = (bundle) => {
    logEvent(eventsData.locale, eventsData.types.selectBundle, eventsData.tags.fromTable, configuration?.configId);

    // console.log("select bundle action", bundle);
    dispatch(setBundle(bundle));
    dispatch(setShowAxisPopup(false));
    // clear the compare list
    dispatch(clearBundlesToCompare());
    dispatch(updateConfiguration());
  };

  return isMobile ? (
    <div className="w-full fixed bottom-0 py-2 px-4">
      {bundlesToCompare?.length === 1 && (
        <Button
          bg="blue"
          classes="w-full flex justify-center rounded-sm !text-base"
          onClick={(e) => {
            e.stopPropagation();
            handleSelectBundle(bundlesToCompare[0]);
          }}
          large
        >
          {t("msizer.ui.select.table.select")}
        </Button>
      )}
      {bundlesToCompare?.length >= 2 && (
        <Button bg="blue" classes="w-full flex justify-center !text-base" onClick={handleCompare} large>
          {t("msizer.ui.select.table.compare")}
        </Button>
      )}
    </div>
  ) : (
    <div className="bg-secondary fixed bottom-0 left-0 w-full py-3 px-20 flex items-center justify-between text-sm text-white drop-shadow-sm">
      <div className="flex items-center space-x-10">
        <div>
          {t("msizer.ui.select.compare_bundles")}: {bundlesToCompare.length}/3
        </div>
        <div
          id="retrofit-select-button-compare-clear"
          onClick={handleClearComparator}
          className="flex items-center space-x-1 cursor-pointer group"
        >
          <MsxIcons name="action_delete" />
          <span className="group-hover:underline">{t("msizer.ui.compare.clear_all")}</span>
        </div>
      </div>
      <div>
        {currentFiltersStep === 1 && (
          <Button
            id="retrofit-select-button-compare"
            classes="rounded border-[1px] py-1 border-white hover:outline hover:outline-1"
            onClick={handleCompare}
          >
            {t("msizer.ui.select.compare_now")}
          </Button>
        )}
        {currentFiltersStep === 2 && (
          <Button
            id="retrofit-select-button-compare"
            classes="rounded border-[1px] py-1 border-white hover:outline hover:outline-1"
            onClick={handleGoBackToResults}
          >
            {t("msizer.ui.select.go_back_to_results")}
          </Button>
        )}
      </div>
    </div>
  );
};

export default ComparisonBar;
